import { render, staticRenderFns } from "./Transition.vue?vue&type=template&id=6d1702b6"
import script from "./Transition.vue?vue&type=script&lang=js"
export * from "./Transition.vue?vue&type=script&lang=js"
import style0 from "./Transition.vue?vue&type=style&index=0&id=6d1702b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports